import React, { Component } from "react";
import "./stylesDraggable.scss";
import { CiWarning } from "react-icons/ci";
import { VscClose } from "react-icons/vsc";
//
//
const userLink = ["https://stripe.com/docs/testing"];

//
//

export default class Dialog extends Component {
  //

  //
  constructor(props) {
    super(props);

    this.state = {
      // 3 calculate the difference
      diffX: 0,
      diffY: 0,
      //   4 Create a Boolean representing IF THE DIALOGUE HAS BEEN DRAG OR NOT
      dragging: false,
      //   5
      styles: {},
    };

    //
    //
    //6 BIND the the "this", the helper functions
    this._dragStart = this._dragStart.bind(this);
    this._dragging = this._dragging.bind(this);
    this._dragEnd = this._dragEnd.bind(this);
    //
    //
  }

  //7
  _dragStart(e) {
    //
    this.setState({
      //8 calculates the difference from the cursor
      diffX: e.screenX - e.currentTarget.getBoundingClientRect().left,
      // 9 to the initial positioning of the dialogue
      diffY: e.screenY - e.currentTarget.getBoundingClientRect().top,
      //
      //10 set the dragging state from false to true
      dragging: true,
    });
  }

  //

  // 12
  _dragging(e) {
    // 15 we don't want the calculation to happen every time, so here i add a conditional to make the that the calculation only happens when the user is dragging
    //
    if (this.state.dragging) {
      var left = e.screenX - this.state.diffX;
      var top = e.screenY - this.state.diffY;
      //
      //13 here you set the states for the styles
      this.setState({
        styles: {
          left: left,
          top: top,
        },
      });
    }
  }

  //
  //

  //11
  //So all what this function is going to do is set the state for the dragging boolean and let us know that the dragging has ended
  _dragEnd() {
    this.setState({
      dragging: false,
    });
  }

  //-----------
  //
  render() {
    //
    //1
    var classes = this.props.show
      ? "absolute-draggable"
      : "absolute-draggable hiddenDraggable ";
    //
    //
    return (
      <div
        className={classes}
        //14
        style={this.state.styles}
        // 2
        onMouseDown={this._dragStart}
        onMouseMove={this._dragging}
        onMouseUp={this._dragEnd}
      >
        <div className="wrapper-dialog-title-and-content">
          <div className="DialogueBar">
            <div className="DialogTitle">
              <CiWarning
                style={{
                  width: `calc(8px + 2vmin)`,
                  height: `calc(8px + 2vmin)`,
                }}
              />
            </div>

            <div className="closeButton" onClick={this.props.onClose}>
              <VscClose
                style={{
                  width: `calc(8px + 2vmin)`,
                  height: `calc(8px + 2vmin)`,
                }}
              />
            </div>
          </div>
          {/* 
          
          
          
          
           */}
          <div className="wrapperContents">
            <h1>
              Please do not enter a real card number when checking out:
              <span>Instead, use this dummy Card for testing purposes:</span>
            </h1>
            <h2>4242 4242 4242 4242 </h2>
            <h3>
              read more about dummy cards in the{" "}
              <a rel="noopener noreferrer" target="_blank" href={userLink}>
                Stripe official
              </a>{" "}
              page
            </h3>
          </div>
        </div>
      </div>
    );
  }
}
